import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Generated from './../../../../assets/img/generated.svg';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';

let genNames = {CRATE_SORTING: 'Inventory Products', BULK_SORTING: 'Inventory Products', IN_TRANSIT_INVENTORY_SORTING: 'Seller Products '};

const SORTING_READINESS_ENABLED_HUBS = ['GJ_AMD_ASL','GJ_AMD_NRD'];

export default class TripTypeGeneration extends Component {
	constructor(props){
		super(props);
		this.state={
			checkedAll: false,
    		trips: [],
    		generatedTrips: [],
    		selectedTrips: [],
    		refreshingTripIds: {},
    		blockerDialogTripId: null,
    		allIssuesDialogOpen: false
  		};
  		this.tripTypeMap = {
  			DIRECT_DELIVERY: 'Direct Deliveries',
  			LAST_MILE: 'Last Mile Trips'
  		};
	};

	componentWillMount() {
		this.initTripsAndSelection(this.props.type.tripJobSummaries, this.props.type);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.type.tripJobSummaries !== this.props.type.tripJobSummaries) {
			this.initTripsAndSelection(nextProps.type.tripJobSummaries, nextProps.type);
		}
	}

	initTripsAndSelection(tripJobSummaries, type) {
		const rawTrips = tripJobSummaries || [];
		const trips = JSON.parse(JSON.stringify(rawTrips));
		const selectedTrips = [];
		const hubLevel = type.needsHubLevelJobGeneration;
		const allReady = this.allNotGeneratedReady(trips);
		trips.forEach(trip => {
			const notGenerated = !this.getGeneratedData(trip).isGenerated;
			const { ready } = this.getTripReadiness(trip);
			if (hubLevel) {
				// Hub-level: all-or-none. Auto-select only when every not-generated trip is ready.
				if (notGenerated && allReady) {
					trip.checkedVal = true;
					selectedTrips.push(trip);
				} else {
					trip.checkedVal = false;
				}
			} else if (notGenerated && ready === true) {
				trip.checkedVal = true;
				selectedTrips.push(trip);
			} else {
				trip.checkedVal = false;
			}
		});
		const checkedAll = selectedTrips.length > 0;
		this.setState({ trips, selectedTrips, checkedAll });
		this.props.tripSelectionPerform({ selectedTrips, selectedType: type.tripType });
	}

	//<!------------------------------ Derive trip-level readiness from phase-level fields ------------------------------!>
	getTripReadiness = (trip) => {
		const phases = (trip.processPhaseLevelDetailsList || []).filter(
			p => p.processStatus !== 'JOBS_GENERATED' && p.processStatus !== 'NOT_REQUIRED'
		);
		if (phases.length === 0) return { ready: null, blockers: [] };

		const hasFalse = phases.some(p => p.isTripReadyForSorting === false);
		const allTrue = phases.every(p => p.isTripReadyForSorting === true);

		const blockers = [];
		phases.forEach(p => {
			if (Array.isArray(p.blockersForSorting)) {
				blockers.push(...p.blockersForSorting);
			} else if (p.blockersForSorting) {
				blockers.push(p.blockersForSorting);
			}
		});

		return {
			ready: hasFalse ? false : (allTrue ? true : null),
			blockers
		};
	}

	//<!------------------------------ Hub-level all-or-none gate: every not-generated trip must be ready ------------------------------!>
	allNotGeneratedReady = (trips) => {
		const notGenerated = (trips || []).filter(t => !this.getGeneratedData(t).isGenerated);
		return notGenerated.length > 0 && notGenerated.every(t => this.getTripReadiness(t).ready === true);
	}

	//<!------------------------------ Handling all check ------------------------------!>
	handleAllCheckChange(){
		var val = true;
		var trips = JSON.parse(JSON.stringify(this.state.trips));
		var selectedTrips = []
		if(this.state.checkedAll) {
			val = false
		}

		if(val) {
			if (this.props.type.needsHubLevelJobGeneration) {
				// Hub-level: all-or-none. Select every not-generated trip only if all are ready, else select none.
				var allReady = this.allNotGeneratedReady(trips);
				for (var i in trips) {
					var notGen = !this.getGeneratedData(trips[i]).isGenerated;
					if (notGen && allReady) {
						trips[i].checkedVal = true;
						selectedTrips.push(trips[i]);
					} else {
						trips[i].checkedVal = false;
					}
				}
			} else {
				for (var k in trips) {
					var trip = trips[k];
					var notGenerated = !this.getGeneratedData(trip).isGenerated;
					var { ready } = this.getTripReadiness(trip);
					var selectable = ready !== false;
					if (notGenerated && selectable) {
						trip.checkedVal = true;
						selectedTrips.push(trip);
					} else if (notGenerated && !selectable) {
						trip.checkedVal = false;
					}
				}
			}
		} else {
			for (var j in trips) {
				trips[j].checkedVal = false;
			}
			selectedTrips = [];
		}

		this.setState({
			selectedTrips: selectedTrips,
			trips: trips,
			checkedAll: val && selectedTrips.length > 0
		});
		var obj = {
			selectedTrips: selectedTrips,
			selectedType: this.props.type.tripType
		};
		this.props.tripSelectionPerform(obj);
	};

	//<!------------------------------ Handing check on a single trip ------------------------------!>
	handleTripCheck(trip) {
		var selectedTrips = this.state.selectedTrips;
		var found;
		for(var i in selectedTrips) {
			if(trip.tripId === selectedTrips[i].tripId) {
				found = i;
			}
		}

		if(found) {
			selectedTrips.splice(found, 1);
			trip.checkedVal=false;
			this.setState({
				checkedAll : false
			})
		} else {
			selectedTrips.push(trip);
			trip.checkedVal=true;
		}

		this.setState({
			selectedTrips : selectedTrips
		});
		var obj = {
			selectedTrips: selectedTrips,
			selectedType: this.props.type.tripType
		};
		this.props.tripSelectionPerform(obj);
	};

	//<!------------------------------ Getting trip's Generation Data ------------------------------!>
	getGeneratedData = (trip) => {
		let isGenerated = true;
		let generated = 0;

		trip.processPhaseLevelDetailsList.forEach(itm => {
			if(itm.processStatus !== 'JOBS_GENERATED' && itm.processStatus !== 'NOT_REQUIRED') {
				isGenerated = false;
			} else {
				generated += 1;
			}
		});
		return {isGenerated: isGenerated, generetedCount: generated};
	}

	//<!------------------------------ Refreshing readiness for a single trip ------------------------------!>
	refreshTripReadiness = (trip) => {
		const selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
		const processPhases = trip.processPhaseLevelDetailsList
			.filter(p => p.processStatus !== 'JOBS_GENERATED' && p.processStatus !== 'NOT_REQUIRED')
			.map(p => p.processPhase);

		this.setState(prev => ({
			refreshingTripIds: { ...prev.refreshingTripIds, [trip.tripId]: true }
		}));

		const req = { tripId: trip.tripId, processPhases, facilityId: selectedFacility.facilityId };

		JobsOperationsApiHandler.refreshSortingReadiness(req)
			.then(resp => {
				const trips = JSON.parse(JSON.stringify(this.state.trips));
				const tripToUpdate = trips.find(t => t.tripId === resp.tripId);

				if (tripToUpdate) {
					const phase = tripToUpdate.processPhaseLevelDetailsList.find(p => p.processPhase === resp.processPhase);
					if (phase) {
						phase.isTripReadyForSorting = resp.isTripReadyForSorting;
						phase.blockersForSorting = resp.blockersForSorting;
					}
					const { ready } = this.getTripReadiness(tripToUpdate);
					const isGenerated = this.getGeneratedData(tripToUpdate).isGenerated;
					if (!isGenerated) {
						if (ready === false) {
							tripToUpdate.checkedVal = false;
						} else if (ready === true) {
							tripToUpdate.checkedVal = true;
						}
					}
				}

				const selectedTrips = trips.filter(t => t.checkedVal);
				const tripAfterUpdate = trips.find(t => t.tripId === resp.tripId);
				const isStillBlocked = tripAfterUpdate && this.getTripReadiness(tripAfterUpdate).ready === false;
				const closeDialog = this.state.blockerDialogTripId === resp.tripId && !isStillBlocked;
				this.setState({ trips, selectedTrips, ...(closeDialog ? { blockerDialogTripId: null } : {}) });
				this.props.tripSelectionPerform({ selectedTrips, selectedType: this.props.type.tripType });
			})
			.catch(() => {})
			.finally(() => {
				this.setState(prev => ({
					refreshingTripIds: { ...prev.refreshingTripIds, [trip.tripId]: false }
				}));
			});
	}

	//<!------------------------------ Blocker dialog open/close ------------------------------!>
	openBlockerDialog = (tripId) => {
		this.setState({ blockerDialogTripId: tripId });
	}

	closeBlockerDialog = () => {
		this.setState({ blockerDialogTripId: null });
	}

	//<!------------------------------ Get human-readable phase name ------------------------------!>
	getPhaseLabel = (phase) => {
		return phase.processPhaseName || genNames[phase.processPhase] || phase.processPhase;
	}

	//<!------------------------------ Phase readiness pills for whitespace area ------------------------------!>
	renderPhasePills = (trip) => {
		return trip.processPhaseLevelDetailsList
			.filter(phase => phase.processStatus !== 'JOBS_GENERATED' && phase.processStatus !== 'NOT_REQUIRED')
			.map((phase, i) => {
				let pillStyle, icon, statusLabel;

				if (phase.isTripReadyForSorting === true) {
					pillStyle = { background: '#e8f5e9', color: '#2e7d32', border: '1px solid #a5d6a7' };
					icon = <i className="fas fa-check-circle" style={{marginRight: '4px', fontSize: '10px'}}/>;
					statusLabel = 'Ready';
				} else if (phase.isTripReadyForSorting === false) {
					pillStyle = { background: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a' };
					icon = <i className="fas fa-exclamation-circle" style={{marginRight: '4px', fontSize: '10px'}}/>;
					statusLabel = 'Blocked';
				} else {
					pillStyle = { background: '#fff8e1', color: '#e65100', border: '1px solid #ffe082' };
					icon = <i className="fas fa-clock" style={{marginRight: '4px', fontSize: '10px'}}/>;
					statusLabel = 'Pending';
				}

				return (
					<span key={i} style={{
						display: 'inline-flex', alignItems: 'center',
						padding: '3px 10px', borderRadius: '12px',
						fontSize: '11px', fontWeight: '500',
						marginRight: '6px', marginBottom: '4px',
						...pillStyle
					}}>
						{icon}
						<span>{statusLabel}</span>
					</span>
				);
			});
	}

	//<!------------------------------- Blocker Dialog ------------------------------!>
	renderBlockerDialog = () => {
		const { blockerDialogTripId } = this.state;
		if (!blockerDialogTripId) return null;

		// Always read from latest state so refresh inside dialog is reflected
		const trip = this.state.trips.find(t => t.tripId === blockerDialogTripId);
		if (!trip) return null;

		const isRefreshing = !!this.state.refreshingTripIds[trip.tripId];

		// Collect only blocked phases
		const blockedPhases = trip.processPhaseLevelDetailsList.filter(
			p => p.processStatus !== 'JOBS_GENERATED' && p.processStatus !== 'NOT_REQUIRED' && p.isTripReadyForSorting === false
		);

		const totalIssues = blockedPhases.reduce((sum, p) => {
			const bl = Array.isArray(p.blockersForSorting) ? p.blockersForSorting : (p.blockersForSorting ? [p.blockersForSorting] : []);
			return sum + bl.length;
		}, 0);

		return (
			<Dialog
				open={true}
				onClose={this.closeBlockerDialog}
				maxWidth="md"
				fullWidth
				PaperProps={{style: {borderRadius: '6px', overflow: 'hidden'}}}
			>
				{/* ---- Dialog Header ---- */}
				<DialogTitle disableTypography style={{padding: '0', margin: '0'}}>
					<div style={{background: '#fff3f3', borderBottom: '2px solid #ffcdd2', padding: '16px 24px'}}>
						<div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
							<div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
								<div style={{
									width: '38px', height: '38px', borderRadius: '50%',
									background: '#ffebee', border: '2px solid #ef9a9a',
									display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
								}}>
									<i className="fas fa-exclamation-triangle" style={{color: '#e21d1d', fontSize: '16px'}}/>
								</div>
								<div>
									<div style={{fontSize: '16px', fontWeight: '700', color: '#c62828', lineHeight: '1.3'}}>
										Sorting Readiness Issues
									</div>
									<div style={{fontSize: '13px', color: '#777', marginTop: '3px', display: 'flex', gap: '12px', alignItems: 'center'}}>
										<span><strong style={{color: '#333'}}>Trip {trip.tripRefNo}</strong></span>
										<span style={{color: '#bbb'}}>|</span>
										<span style={{fontFamily: 'monospace', fontSize: '12px', background: '#f0f0f0', padding: '1px 6px', borderRadius: '3px'}}>{trip.tripId}</span>
										<span style={{color: '#bbb'}}>|</span>
										<span style={{
											background: '#ffebee', color: '#c62828',
											padding: '1px 8px', borderRadius: '10px',
											fontSize: '11px', fontWeight: '600', border: '1px solid #ef9a9a'
										}}>
											{totalIssues} Issue{totalIssues !== 1 ? 's' : ''} Found
										</span>
									</div>
								</div>
							</div>
							<button
								onClick={this.closeBlockerDialog}
								style={{
									background: 'none', border: 'none', cursor: 'pointer',
									color: '#999', fontSize: '18px', padding: '4px',
									lineHeight: '1', borderRadius: '4px'
								}}
							>
								<i className="fas fa-times"/>
							</button>
						</div>
					</div>
				</DialogTitle>

				{/* ---- Dialog Body ---- */}
				<DialogContent style={{padding: '20px 24px', background: '#fafafa'}}>
					<p style={{fontSize: '13px', color: '#666', margin: '0 0 16px 0', lineHeight: '1.5'}}>
						The following issues are blocking this trip from sorting job generation.
					</p>

					{blockedPhases.length > 0 ? blockedPhases.map((phase, pi) => {
						const phaseName = this.getPhaseLabel(phase);
						const phaseBlockers = Array.isArray(phase.blockersForSorting)
							? phase.blockersForSorting
							: (phase.blockersForSorting ? [phase.blockersForSorting] : []);

						return (
							<div key={pi} style={{marginBottom: '16px', borderRadius: '6px', overflow: 'hidden', border: '1px solid #ffcdd2', boxShadow: '0 1px 3px rgba(0,0,0,0.06)'}}>

								{/* Phase header */}
								<div style={{
									background: '#ffebee', padding: '10px 16px',
									display: 'flex', alignItems: 'center', gap: '8px',
									borderBottom: '1px solid #ffcdd2'
								}}>
									<i className="fas fa-layer-group" style={{color: '#e21d1d', fontSize: '12px'}}/>
									<span style={{fontWeight: '600', fontSize: '13px', color: '#c62828', flex: 1}}>{phaseName}</span>
									<span style={{
										background: '#fff', border: '1px solid #ef9a9a',
										color: '#c62828', borderRadius: '10px',
										fontSize: '11px', padding: '1px 8px', fontWeight: '600'
									}}>
										{phaseBlockers.length} blocker{phaseBlockers.length !== 1 ? 's' : ''}
									</span>
								</div>

								{/* Issues table */}
								<table style={{width: '100%', borderCollapse: 'collapse', background: '#fff'}}>
									<thead>
										<tr style={{background: '#f9f9f9'}}>
											<th style={{
												padding: '8px 16px', textAlign: 'center',
												fontSize: '11px', color: '#999', fontWeight: '600',
												width: '48px', borderBottom: '1px solid #f0e0e0',
												textTransform: 'uppercase', letterSpacing: '0.5px'
											}}>#</th>
											<th style={{
												padding: '8px 16px', textAlign: 'left',
												fontSize: '11px', color: '#999', fontWeight: '600',
												borderBottom: '1px solid #f0e0e0',
												textTransform: 'uppercase', letterSpacing: '0.5px'
											}}>Issue Details</th>
										</tr>
									</thead>
									<tbody>
										{phaseBlockers.length > 0 ? phaseBlockers.map((blocker, bi) => (
											<tr key={bi} style={{borderBottom: bi < phaseBlockers.length - 1 ? '1px solid #fce4e4' : 'none'}}>
												<td style={{
													padding: '12px 16px', textAlign: 'center',
													fontSize: '12px', color: '#bbb',
													fontWeight: '700', verticalAlign: 'top'
												}}>
													<span style={{
														display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
														width: '22px', height: '22px', borderRadius: '50%',
														background: '#ffebee', color: '#e21d1d',
														fontSize: '11px', fontWeight: '700'
													}}>{bi + 1}</span>
												</td>
												<td style={{
													padding: '12px 16px', fontSize: '13px',
													color: '#333', lineHeight: '1.7',
													verticalAlign: 'top', wordBreak: 'break-word'
												}}>
													{blocker}
												</td>
											</tr>
										)) : (
											<tr>
												<td colSpan={2} style={{padding: '16px', fontSize: '13px', color: '#999', fontStyle: 'italic', textAlign: 'center'}}>
													No specific blocker details available for this phase.
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						);
					}) : (
						<div style={{
							textAlign: 'center', padding: '32px',
							background: '#fff3f3', borderRadius: '6px',
							border: '1px solid #ffcdd2'
						}}>
							<i className="fas fa-exclamation-circle" style={{fontSize: '28px', color: '#e21d1d', marginBottom: '10px', display: 'block'}}/>
							<div style={{fontSize: '14px', color: '#c62828', fontWeight: '600'}}>Trip is not ready for sorting</div>
							<div style={{fontSize: '12px', color: '#999', marginTop: '6px'}}>No specific phase details available. Try refreshing the status.</div>
						</div>
					)}
				</DialogContent>

				{/* ---- Dialog Footer ---- */}
				<DialogActions style={{padding: '12px 24px', borderTop: '1px solid #eee', background: '#fff', justifyContent: 'space-between'}}>
					<div style={{fontSize: '12px', color: '#aaa'}}>
						<i className="fas fa-info-circle" style={{marginRight: '4px'}}/>
						Last checked: just now
					</div>
					<div style={{display: 'flex', gap: '10px'}}>
						<Button
							onClick={() => this.refreshTripReadiness(trip)}
							disabled={isRefreshing}
							style={{
								border: '1px solid #ddd', color: '#555',
								padding: '6px 16px', borderRadius: '4px',
								fontSize: '13px', textTransform: 'none',
								background: '#fff', minWidth: '120px'
							}}
						>
							{isRefreshing
								? <span><CircularProgress size={12} thickness={3} style={{marginRight: '6px', color: '#555'}}/> Refreshing…</span>
								: <span><i className="fas fa-sync-alt" style={{marginRight: '6px', fontSize: '11px'}}/> Refresh Status</span>
							}
						</Button>
						<Button
							onClick={this.closeBlockerDialog}
							style={{
								background: '#333', color: '#fff',
								padding: '6px 20px', borderRadius: '4px',
								fontSize: '13px', textTransform: 'none'
							}}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}

	//<!------------------------------- All Issues Dialog ------------------------------!>
	renderAllIssuesDialog = () => {
		if (!this.state.allIssuesDialogOpen) return null;

		const blockedTrips = this.state.trips.filter(t => this.getTripReadiness(t).ready === false);
		if (blockedTrips.length === 0) return null;

		const totalIssues = blockedTrips.reduce((sum, trip) => {
			const blockedPhases = trip.processPhaseLevelDetailsList.filter(
				p => p.processStatus !== 'JOBS_GENERATED' && p.processStatus !== 'NOT_REQUIRED' && p.isTripReadyForSorting === false
			);
			return sum + blockedPhases.reduce((s, p) => {
				const bl = Array.isArray(p.blockersForSorting) ? p.blockersForSorting : (p.blockersForSorting ? [p.blockersForSorting] : []);
				return s + bl.length;
			}, 0);
		}, 0);

		return (
			<Dialog
				open={true}
				onClose={() => this.setState({ allIssuesDialogOpen: false })}
				maxWidth="md"
				fullWidth
				PaperProps={{style: {borderRadius: '6px', overflow: 'hidden'}}}
			>
				<DialogTitle disableTypography style={{padding: '0', margin: '0'}}>
					<div style={{background: '#fff3f3', borderBottom: '2px solid #ffcdd2', padding: '16px 24px'}}>
						<div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
							<div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
								<div style={{
									width: '38px', height: '38px', borderRadius: '50%',
									background: '#ffebee', border: '2px solid #ef9a9a',
									display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
								}}>
									<i className="fas fa-exclamation-triangle" style={{color: '#e21d1d', fontSize: '16px'}}/>
								</div>
								<div>
									<div style={{fontSize: '16px', fontWeight: '700', color: '#c62828', lineHeight: '1.3'}}>
										Sorting Readiness Issues
									</div>
									<div style={{fontSize: '13px', color: '#777', marginTop: '3px', display: 'flex', gap: '12px', alignItems: 'center'}}>
										<strong style={{color: '#333'}}>{blockedTrips.length} Blocked Trip{blockedTrips.length !== 1 ? 's' : ''}</strong>
										<span style={{color: '#bbb'}}>|</span>
										<span style={{
											background: '#ffebee', color: '#c62828',
											padding: '1px 8px', borderRadius: '10px',
											fontSize: '11px', fontWeight: '600', border: '1px solid #ef9a9a'
										}}>
											{totalIssues} Issue{totalIssues !== 1 ? 's' : ''} Found
										</span>
									</div>
								</div>
							</div>
							<button
								onClick={() => this.setState({ allIssuesDialogOpen: false })}
								style={{background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: '18px', padding: '4px', lineHeight: '1', borderRadius: '4px'}}
							>
								<i className="fas fa-times"/>
							</button>
						</div>
					</div>
				</DialogTitle>

				<DialogContent style={{padding: '20px 24px', background: '#fafafa'}}>
					<p style={{fontSize: '13px', color: '#666', margin: '0 0 16px 0', lineHeight: '1.5'}}>
						The following issues are blocking trips from sorting job generation.
					</p>
					{blockedTrips.map((trip, ti) => {
						const blockedPhases = trip.processPhaseLevelDetailsList.filter(
							p => p.processStatus !== 'JOBS_GENERATED' && p.processStatus !== 'NOT_REQUIRED' && p.isTripReadyForSorting === false
						);
						return (
							<div key={ti} style={{marginBottom: '20px'}}>
								<div style={{
									fontSize: '13px', fontWeight: '700', color: '#333',
									marginBottom: '10px', padding: '8px 12px',
									background: '#f5f5f5', borderRadius: '4px', border: '1px solid #e0e0e0',
									display: 'flex', gap: '10px', alignItems: 'center'
								}}>
									<span>Trip {trip.tripRefNo}</span>
									<span style={{color: '#bbb'}}>|</span>
									<span style={{fontFamily: 'monospace', fontSize: '12px', background: '#f0f0f0', padding: '1px 6px', borderRadius: '3px'}}>{trip.tripId}</span>
								</div>
								{blockedPhases.map((phase, pi) => {
									const phaseName = this.getPhaseLabel(phase);
									const phaseBlockers = Array.isArray(phase.blockersForSorting)
										? phase.blockersForSorting
										: (phase.blockersForSorting ? [phase.blockersForSorting] : []);
									return (
										<div key={pi} style={{marginBottom: '12px', borderRadius: '6px', overflow: 'hidden', border: '1px solid #ffcdd2', boxShadow: '0 1px 3px rgba(0,0,0,0.06)'}}>
											<div style={{background: '#ffebee', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: '8px', borderBottom: '1px solid #ffcdd2'}}>
												<i className="fas fa-layer-group" style={{color: '#e21d1d', fontSize: '12px'}}/>
												<span style={{fontWeight: '600', fontSize: '13px', color: '#c62828', flex: 1}}>{phaseName}</span>
												<span style={{background: '#fff', border: '1px solid #ef9a9a', color: '#c62828', borderRadius: '10px', fontSize: '11px', padding: '1px 8px', fontWeight: '600'}}>
													{phaseBlockers.length} blocker{phaseBlockers.length !== 1 ? 's' : ''}
												</span>
											</div>
											<table style={{width: '100%', borderCollapse: 'collapse', background: '#fff'}}>
												<thead>
													<tr style={{background: '#f9f9f9'}}>
														<th style={{padding: '8px 16px', textAlign: 'center', fontSize: '11px', color: '#999', fontWeight: '600', width: '48px', borderBottom: '1px solid #f0e0e0', textTransform: 'uppercase', letterSpacing: '0.5px'}}>#</th>
														<th style={{padding: '8px 16px', textAlign: 'left', fontSize: '11px', color: '#999', fontWeight: '600', borderBottom: '1px solid #f0e0e0', textTransform: 'uppercase', letterSpacing: '0.5px'}}>Issue Details</th>
													</tr>
												</thead>
												<tbody>
													{phaseBlockers.map((blocker, bi) => (
														<tr key={bi} style={{borderBottom: bi < phaseBlockers.length - 1 ? '1px solid #fce4e4' : 'none'}}>
															<td style={{padding: '12px 16px', textAlign: 'center', fontSize: '12px', color: '#bbb', fontWeight: '700', verticalAlign: 'top'}}>
																<span style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '22px', height: '22px', borderRadius: '50%', background: '#ffebee', color: '#e21d1d', fontSize: '11px', fontWeight: '700'}}>{bi + 1}</span>
															</td>
															<td style={{padding: '12px 16px', fontSize: '13px', color: '#333', lineHeight: '1.7', verticalAlign: 'top', wordBreak: 'break-word'}}>
																{blocker}
															</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									);
								})}
							</div>
						);
					})}
				</DialogContent>

				<DialogActions style={{padding: '12px 24px', borderTop: '1px solid #eee', background: '#fff', justifyContent: 'flex-end'}}>
					<Button
						onClick={() => this.setState({ allIssuesDialogOpen: false })}
						style={{background: '#333', color: '#fff', padding: '6px 20px', borderRadius: '4px', fontSize: '13px', textTransform: 'none'}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	//<!------------------------------ Rendring trips ------------------------------!>
	notGeneratedtripsData() {
		var tripsData = this.state.trips.map((trip, index) => {
			if(trip.checkedVal === undefined) {
				trip.checkedVal = false;
			}
			let generationData = this.getGeneratedData(trip);
			let isGenerated = generationData.isGenerated;
			let generetedCount = generationData.generetedCount;
			const { ready } = this.getTripReadiness(trip);

			// Row left-border accent color
			let accentColor = '#e0e0e0';
			if (isGenerated) accentColor = '#58a159';
			else if (ready === false) accentColor = '#e21d1d';
			else if (ready === true) accentColor = '#58a159';

			// Status badge config
			let statusBadge = null;
			if (!isGenerated) {
				if (ready === false) {
					statusBadge = {bg: '#ffebee', color: '#c62828', border: '#ef9a9a', text: 'Not Ready', icon: 'fas fa-times-circle'};
				} else if (ready === true) {
					statusBadge = {bg: '#e8f5e9', color: '#2e7d32', border: '#a5d6a7', text: 'Ready for Sorting', icon: 'fas fa-check-circle'};
				} else {
					statusBadge = {bg: '#f5f5f5', color: '#757575', border: '#e0e0e0', text: 'Not Generated', icon: 'fas fa-clock'};
				}
			}

			return (
				<div
					className="trip-in-hub-outer"
					key={index}
					style={{borderLeft: `3px solid ${accentColor}`, padding: '14px 16px', margin: '10px 0 0 0'}}
				>
					<div style={{display: 'flex', alignItems: 'center', gap: '0', minHeight: '48px'}}>

						{/* ── Col 1: Checkbox ── */}
						<div style={{flexShrink: 0, width: '44px'}}>
							{!isGenerated && (
								<Checkbox
									checked={trip.checkedVal}
									onClick={() => this.handleTripCheck(trip)}
									value="checkG"
									classes={{root: 'cstmCheckBox', checked: 'greenChecked'}}
									disabled={this.props.type.needsHubLevelJobGeneration || ready === false}
								/>
							)}
						</div>

						{/* ── Col 2: Trip ID ── */}
						<div style={{flexShrink: 0, width: '168px', paddingRight: '16px', borderRight: '1px solid #f0f0f0'}}>
							<div style={{fontSize: '14px', fontWeight: '600', color: '#222', lineHeight: '1.3'}}>
								Trip {trip.tripRefNo}
							</div>
							<div style={{
								fontSize: '11px', color: '#999', marginTop: '5px',
								fontFamily: 'monospace', background: '#f7f7f7',
								display: 'inline-block', padding: '1px 5px',
								borderRadius: '3px', letterSpacing: '0.3px'
							}}>
								{trip.tripId}
							</div>
						</div>

						{/* ── Col 3: Middle whitespace — phase pills OR generated details ── */}
						<div style={{flex: 1, padding: '0 20px'}}>
							{isGenerated ? (
								generetedCount ? (
									<div style={{display: 'flex', gap: '32px'}}>
										<div>
											<div className="trip-info-label">Type of Products</div>
											{trip.processPhaseLevelDetailsList.map((itm, i) => {
												if(itm.processStatus === 'JOBS_GENERATED') {
													return <div key={i} className="trip-info-value">{itm.processPhaseName ? itm.processPhaseName : genNames[itm.processPhase]}</div>
												} return null;
											})}
										</div>
										<div>
											<div className="trip-info-label">FC Hero</div>
											{trip.processPhaseLevelDetailsList.map((itm, i) => {
												if(itm.processStatus === 'JOBS_GENERATED') {
													return <div key={i} className="trip-info-value">{itm.userName} ({itm.userId})</div>
												} return null;
											})}
										</div>
									</div>
								) : null
							) : (
								<div>
										<div style={{
											fontSize: '10px', color: '#bbb',
											textTransform: 'uppercase', letterSpacing: '0.7px',
											marginBottom: '7px', fontWeight: '600'
										}}>
											Sorting Readiness
										</div>
										<div style={{display: 'flex', flexWrap: 'wrap'}}>
											{this.renderPhasePills(trip)}
										</div>
									</div>
								)}
						</div>

						{/* ── Col 4: Status badge + action buttons ── */}
						<div style={{flexShrink: 0, minWidth: '200px', textAlign: 'right', paddingLeft: '16px', borderLeft: '1px solid #f0f0f0'}}>
							{isGenerated ? (
								<div style={{
									display: 'inline-flex', alignItems: 'center', gap: '6px',
									background: '#e8f5e9', color: '#2e7d32',
									padding: '6px 14px', borderRadius: '20px',
									fontSize: '13px', fontWeight: '500',
									border: '1px solid #a5d6a7'
								}}>
									<img src={Generated} alt="Generated" width="14px"/>
									Generated
								</div>
							) : (
								<div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px'}}>

									{/* Status badge */}
									<div style={{
										display: 'inline-flex', alignItems: 'center', gap: '5px',
										background: statusBadge.bg, color: statusBadge.color,
										padding: '5px 12px', borderRadius: '20px',
										fontSize: '12px', fontWeight: '600',
										border: `1px solid ${statusBadge.border}`
									}}>
										<i className={statusBadge.icon} style={{fontSize: '11px'}}/>
										{statusBadge.text}
									</div>
										{ready === false && (
											<button
												onClick={() => this.openBlockerDialog(trip.tripId)}
												style={{
													display: 'inline-flex', alignItems: 'center', gap: '5px',
													background: '#fff3f3', border: '1px solid #ffcdd2',
													borderRadius: '4px', padding: '5px 12px',
													cursor: 'pointer', fontSize: '12px', color: '#c62828',
													fontWeight: '500'
												}}
											>
												<i className="fas fa-exclamation-circle" style={{fontSize: '11px'}}/>
												<span>View Issues</span>
											</button>
										)}
								</div>
							)}
						</div>

					</div>
				</div>
			);
		});
		return tripsData;
	}

	render() {
		return (
			<div style={{position:'relative'}}>
				{(this.props.selectionFrom && this.props.selectionFrom !== this.props.type.tripType)?
					<div className="blocked-selection-box"></div>:null
				}
				<div className="hub-trip-outer">
					<div style={{padding:'0px 14px', display:'flex', alignItems:'center'}}>
						{(this.state.trips.length > 0) ?
							<span style={{marginRight:'10px'}}>
								<Checkbox checked={this.state.checkedAll} onChange={this.handleAllCheckChange.bind(this)} value="checkedG" classes={{root:'cstmCheckBox',checked:'greenChecked'}} disabled={this.props.type.needsHubLevelJobGeneration && !this.allNotGeneratedReady(this.state.trips)}/>
							</span>: null
						}
						<span style={{lineHeight:'22px',fontSize:'17px'}}>{this.tripTypeMap[this.props.type.tripType]}</span>
						{(this.props.type.needsHubLevelJobGeneration)?
						 	<span style={{color:'#e21d1d',marginLeft:'10px', fontSize:'13px'}}>
						 		(Only Hub Level Sorting Generation is allowed for this Facility)
						 	</span>:null
						}
						{(this.props.type.needsHubLevelJobGeneration && this.state.trips.some(t => !this.getGeneratedData(t).isGenerated) && !this.allNotGeneratedReady(this.state.trips))?
						 	<span style={{color:'#e65100',marginLeft:'10px', fontSize:'12px'}}>
						 		(All trips must be ready before hub-level jobs can be generated)
						 	</span>:null
						}
						{this.state.trips.some(t => !this.getGeneratedData(t).isGenerated) && (
							<div style={{marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'center'}}>
								{this.state.trips.some(t => this.getTripReadiness(t).ready === false) && (
									<button
										onClick={() => this.setState({ allIssuesDialogOpen: true })}
										style={{
											display: 'inline-flex', alignItems: 'center', gap: '5px',
											background: '#fff3f3', border: '1px solid #ffcdd2',
											borderRadius: '4px', padding: '5px 12px',
											cursor: 'pointer', fontSize: '12px', color: '#c62828', fontWeight: '500'
										}}
									>
										<i className="fas fa-exclamation-circle" style={{fontSize: '11px'}}/>
										<span>View Issues</span>
									</button>
								)}
								<button
									onClick={this.props.onRefresh}
									style={{
										display: 'inline-flex', alignItems: 'center', gap: '5px',
										background: '#fff', border: '1px solid #ddd',
										borderRadius: '4px', padding: '5px 12px',
										cursor: 'pointer', fontSize: '12px', color: '#555'
									}}
								>
									<i className="fas fa-sync-alt" style={{fontSize: '11px'}}/>
									<span>Refresh</span>
								</button>
							</div>
						)}
					</div>

					{/* ── Legend strip ── */}
					{this.state.trips.some(t => !this.getGeneratedData(t).isGenerated) ?
						<div style={{
							margin: '10px 0 0 0', padding: '8px 14px',
							background: '#f9f9f9', borderTop: '1px solid #eee',
							borderBottom: '1px solid #eee', display: 'flex',
							gap: '20px', flexWrap: 'wrap', fontSize: '12px', color: '#666'
						}}>
							<span style={{display:'inline-flex', alignItems:'center', gap:'5px'}}>
								<span style={{width:'9px',height:'9px',borderRadius:'50%',background:'#58a159',display:'inline-block'}}/>
								Ready for sorting <em>(checkbox enabled)</em>
							</span>
							<span style={{display:'inline-flex', alignItems:'center', gap:'5px'}}>
								<i className="fas fa-exclamation-circle" style={{color:'#e21d1d', fontSize:'12px'}}/>
								Not ready — click <strong style={{marginLeft:'2px'}}>View Issues</strong> for full details
							</span>
						</div>
						: null
					}

					<div style={{marginTop:'10px'}}>
						{this.notGeneratedtripsData()}
					</div>
				</div>

				{/* ── Blocker Dialog ── */}
				{this.renderBlockerDialog()}
				{this.renderAllIssuesDialog()}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/TripTypeGeneration.js